import React, {Component} from 'react';
import VisConf from './VisConf';
import lang from '../../Lang/lang.json';
import Icons from '../../../Containers/Icons';

class PointsConf extends Component {
  constructor(){
    super();
    this.state = {
      vis: [],
      selected: "",
      newVis: {}
    }
  }
  componentDidMount() {
    this.readVis();
    this.props.changeScreen("PointCnf");
  }
  readVis = () => {
    let {url, tkn} = this.props;
    let bodyCall = {
      type: "read",
      screen: "vis-conf",
      tkn: tkn
    }
    fetch(`${url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res.tkn === false) {
        this.props.logOut();
      } else {
        Object.keys(res).map(el => {
          return res[el]["active"] = false;
        })
        this.setState({vis: res});
      }
    })
  }
  closeDel = () => {
    this.props.funct('PointCnfDel');
    let selected = {...this.state.vis};
    Object.keys(selected).map(el => {
      return selected[el].active = false;
    })
    this.setState({vis: selected})
  }
  selectVis = (index) => {
    this.props.funct("PointCnfDel")
    let selected = {...this.state.vis};
    console.log(selected)
    selected[index].active
    ? selected[index].active = false
    : selected[index].active = true
    this.setState({vis: selected, selected: index})
    console.log(this.state.vis[this.state.selected])
  }
  removeVis = () => {
    let bodyCall = {
      type: "delete",
      screen: "vis",
      post: {
        id: this.state.vis[this.state.selected].id
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      console.log(res)
      this.readVis();
      this.props.funct("PointCnfDel")
      this.props.msg('ok', 'e15');
    })
  } 
  saveNewVis = () => {
    let bodyCall = {
      type: "create",
      screen: "vis",
      post: {
        abr: this.state.newVis.abr,
        name: this.state.newVis.name
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res === true) {
        this.readVis();
        this.props.funct("PointCnf");
        this.props.msg('ok', 'e14');
      }
    })
  }
  newVisData = (e) => {
    let newData = this.state.newVis;
    if (e.target.name === "abr") {
      newData.abr = e.target.value
    } else {
      newData.name = e.target.value
    }
    this.setState({newVis: newData})
  }
  clearVisInfo = () => {
    let input = document.querySelectorAll('input');
    Object.keys(input).map(key => {
      input[key].value = "";
      return true;
    })
    this.props.funct("PointCnf");
  }
  render() {
    let {vis} = this.state;
    let openModDel;
    this.props.openModDel
    ? openModDel = "open"
    : openModDel = "closed"
    let openMod;
    this.props.openMod
    ? openMod = "open"
    : openMod = "closed"
    return (
      <div id="pointsconf">
        <ul>
        {
          Object.keys(vis).map(el => {
            return (
              <VisConf 
                key={el}
                index={el}
                selectVis={this.selectVis}
                funct={this.props.funct}
                url={this.props.url} 
                tkn={this.props.tkn}
                selected={openModDel}
                disSelect={this.state.disSelect}
                readVis={this.readVis} 
                vis={vis[el]}/>
            )
          })
        }
        </ul>
        <div className={`modal delete ${openModDel}`}>
          <span className="formButton ok white" onClick={this.removeVis}>
            <Icons name="ok"/>
          </span>
          <span className="info">
            <h3>{lang.UsrCnf.delete[this.props.language]}</h3>
            <p>{lang.PointCnf.deleteinfo[this.props.language]}</p>
          </span>
          <span 
            className="formButton close white" 
            onClick={() => this.closeDel()}>
            <Icons name="close"/>
          </span>
        </div>
        <div id="overmodal" className={`${openModDel}`}>
        </div>
        <form className={`modal add ${openMod}`}>
          <h3>{lang.PointCnf.title[this.props.language]}</h3>
          <input 
            autoComplete="abr"
            name="abr"
            type="text" 
            placeholder={lang.PointCnf.abr[this.props.language]}
            onChange={this.newVisData}/>
          <input 
            autoComplete="Name"
            name="name"
            type="text" 
            placeholder={lang.PointCnf.name[this.props.language]}
            onChange={this.newVisData}/>
          <p>{lang.PointCnf.createInfo[this.props.language]}</p>
          <span className="formButtonsContainer">
            <span className="formButton ok" onClick={this.saveNewVis}>
              <Icons name="ok"/>
            </span>
            <span className="formButton close" onClick={this.clearVisInfo}>
              <Icons name="close"/>
            </span>
          </span>
        </form>
      </div>
    )
  }
}
export default PointsConf;


// WEBPACK FOOTER //
// ./src/Components/Admin/Point/PointsConf.js